<template>
  <!-- TODO: Remove important styles -->
  <Tree
    v-model:expanded-keys="treeExpandedKeys"
    :value="items"
    :loading="true"
    loading-mode="icon"
    class="tree-display !bg-transparent !p-0"
    :pt="{
      rootChildren: '!pt-0 !gap-6',
      nodeContent: '!p-0',
      nodeLabel: 'overflow-hidden w-full',
      nodeChildren: '!pl-0',
    }"
    @node-expand="$emit('node-expand', $event)"
    @node-collapse="$emit('node-collapse', $event)"
  >
    <template #nodetoggleicon="slotProps">
      <slot
        v-if="$slots.nodetoggleicon"
        name="nodetoggleicon"
        v-bind="slotProps"
      />
      <UiLucideIcon
        v-else
        :icon="
          slotProps.node.loading
            ? Loader
            : slotProps.expanded
              ? ChevronDown
              : ChevronRight
        "
        :class="{ 'animate-spin': slotProps.node.loading }"
      />
    </template>

    <template
      v-if="$slots.nodeicon"
      #nodeicon="slotProps"
    >
      <slot
        name="nodeicon"
        v-bind="slotProps"
      />
    </template>

    <template
      v-if="$slots.default"
      #default="slotProps"
    >
      <slot
        name="default"
        v-bind="slotProps"
      />
    </template>
  </Tree>
</template>

<script lang="ts" setup>
import { ChevronDown, ChevronRight, Loader } from 'lucide-vue-next'

const props = defineProps({
  items: { type: Array, required: true, default: () => [] },
  expandedKeys: { type: Object, default: () => {} },
})
defineEmits(['node-expand', 'node-collapse'])

const treeExpandedKeys = ref(props.expandedKeys)
watch(props.expandedKeys, (newExpandedKeys) => {
  treeExpandedKeys.value = { ...treeExpandedKeys.value, ...newExpandedKeys }
})
</script>

<style lang="scss">
.tree-display {
  .p-tree-node {
    @apply overflow-hidden;

    &.p-tree-node-leaf {
      .p-tree-node-toggle-button,
      .p-tree-node-icon {
        @apply hidden;
      }
    }
  }
}
</style>
